module.exports = __webpack_public_path__ + "img/copy3.58863387.svg";